import sortBy from 'lodash/sortBy';
import NextLink from 'next/link';
import { ISitemapPage } from './generate-sitemap/page-data-to-sitemap-xml';
import styles from './sitemap.module.scss';

export interface ISitemapProps {
	data: Record<string, ISitemapPage[]>;
}

export const Sitemap = ({ data }: ISitemapProps): React.JSX.Element => {
	// Flatten all items in single array
	const pageList = Object.keys(data).flatMap((item) => data[item]);

	const pageGroupList = createGroupsFromPages(pageList);

	return (
		<div className={styles.sitemap}>
			<ul>
				{pageGroupList.map((group, index) => {
					return (
						<li key={`sitemap-group-${index}`}>
							<NextLink href={`/${group.path}`}>{group.title}</NextLink>

							{group.items.length > 0 && (
								<ul>
									{group.items.map(({ fullPath, title }) => {
										return (
											<li key={fullPath}>
												<NextLink href={`/${fullPath}`}>{title}</NextLink>
											</li>
										);
									})}
								</ul>
							)}
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default Sitemap;

interface ISitemapGroup {
	title: string;
	path: string;
	items: ISitemapPage[];
}

const createGroupsFromPages = (pages: ISitemapPage[] = []): ISitemapGroup[] => {
	const groups: ISitemapGroup[] = [];

	const groupBases = pages.filter((page) => page.fullPath?.split('/').length === 1);

	for (const groupBase of groupBases) {
		const groupPath = groupBase.fullPath?.split('/')?.[0] || '';

		const groupExists = groups?.find((group) => group.path === groupPath);

		if (!groupExists) {
			const subPages = pages.filter((x) => {
				const splitSlug = x.fullPath?.split('/');
				return splitSlug && splitSlug.length > 1 && splitSlug?.[0] === groupPath;
			});

			const group = {
				title: groupBase.title,
				path: groupPath,
				items: sortBy(subPages, [(subPage) => subPage.title.toLocaleLowerCase()])
			};

			groups.push(group);
		}
	}

	return sortBy(groups, [(group) => group.title.toLocaleLowerCase()]);
};
